<template>
  <div id="basic-modal">
    <v-dialog
      transition="dialog-top-transition"
      width="340px"
      v-model="showModal"
    >
      <v-card height="auto">
        <v-toolbar
          color="primary"
          :title="title"
        >
          <v-btn
            icon
            dark
          >
            <v-icon @click="cancelButtonClicked">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="text-subtitle-1 py-4" :class="textAlign" v-html="description"></div>
        </v-card-text>
        <v-card-actions :class="cancelButton ? 'justify-space-between' : 'justify-space-evenly'">
          <v-btn
            v-if="cancelButton"
            variant="text"
            @click="cancelButtonClicked"
          >{{ cancelButton }}</v-btn>
          <v-btn
            variant="text"
            @click="okButtonClicked"
          >{{ okButton }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: "BasicModal",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    okButton: {
      type: String,
      required: true,
    },
    cancelButton: {
      type: String,
      required: true,
    },
    showModalProp: {
      type: Boolean,
      default: false,
    },
    textAlign: {
      type: String,
      default: 'text-center',
    },
  },
  data() {
    return {
      showModal: false,
    }
  },
  created() {
    this.showModal = true;
  },
  methods: {
    okButtonClicked() {
      this.emitter.emit('okButtonClicked');
      this.showModal = false;
      if (!this.cancelButton) {
        setTimeout(() => {
          this.emitter.emit('closeModal');
        }, 300);
      } else {
        setTimeout(() => {
          this.emitter.emit('closeModal');
        }, 2000);
      }
    },
    cancelButtonClicked() {
      this.showModal = false;
      setTimeout(() => {
        this.emitter.emit('closeModal');
      }, 300);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>